import { toast } from '@/hooks/use-toast';

export const handleNetworkError = (message: string): never => {
  toast({
    title: 'Fel',
    description: message,
    variant: 'default',
  });
  throw new Error(`Network error: ${message}`);
};
